import DataLabelValueComponent from "../../../components/data-label-value/DataLabelValueComponent";
import { CommonService } from "../../../helpers";
import React from "react";

interface PerDiemCardComponentProps {
    jobDetails?: any;
}
const PerDiemCardComponent = (props: PerDiemCardComponentProps) => {
    const { jobDetails } = props;

    return (
        <div className={'d-flex'}>
            <DataLabelValueComponent label={'Start Date'} className={'flex-equal'}>
                {jobDetails?.per_diem_details?.start_date ? CommonService.formattedDate(jobDetails?.per_diem_details?.start_date) : 'ASAP'}
            </DataLabelValueComponent>
            {Boolean(jobDetails?.per_diem_details?.end_date) && (
                <DataLabelValueComponent label={'End Date'} className={'flex-equal'}>
                    {CommonService.formattedDate(jobDetails.per_diem_details.end_date)}
                </DataLabelValueComponent>
            )}
            {typeof (jobDetails?.per_diem_details?.start_time) === "number" && (
                <DataLabelValueComponent label={'Start Time'} className={'flex-equal'}>
                    {CommonService.convertMinsToHrsMins(jobDetails?.per_diem_details?.start_time)}
                </DataLabelValueComponent>
            )}
            {typeof (jobDetails?.per_diem_details?.end_time) === "number" && (
                <DataLabelValueComponent label={'End Time'} className={'flex-equal'}>
                    {CommonService.convertMinsToHrsMins(jobDetails?.per_diem_details?.end_time)}
                </DataLabelValueComponent>
            )}
            <DataLabelValueComponent label={'Shift Time'} className={'flex-equal'}>
                {jobDetails?.per_diem_details?.shift_type ? CommonService.formatTitleCase(jobDetails?.per_diem_details?.shift_type) : 'AM'}
            </DataLabelValueComponent>
        </div>
    )
}
export default PerDiemCardComponent
